<div style="display: flex; height: 100%;">
  <div style="display: flex; overflow: auto; width: 100%;">
    <div style="display: flex; flex-direction: column; padding: 20px; z-index: 1; width: 100%;">
      <mat-toolbar color="primary" class="toolbar-over-card"
        style="padding: 20px; align-items: center; justify-content: space-between;">
        <!-- Title -->
        <div><span>Review Sets</span></div>
        <div style="display: flex; font-size: medium;">
          <button style="padding: 0 16px;" *inRole="[roles.AccountFeatureSet, roles.Administrator]" mat-button
            aria-label="Add Field" [routerLink]="['/','discovery','review-tracking']">
            <div class="fal fa-line-chart" style="font-size: 18px; margin-right: 10px; margin-top: 7px;"></div>
            <span>Review Tracking</span>
          </button>
          <button style="padding: 0 16px;" *inRole="[roles.Employee]" mat-button aria-label="Add Field"
            [routerLink]="['/','discovery','ai-review']">
            <div class="far fa-stars" style="font-size: 18px; margin-right: 10px; margin-top: 7px;"></div>
            <span>AI Review Insights</span>
          </button>
          <button style="padding: 0 16px;" *inRole="[roles.AccountFeatureSet, roles.Administrator]" mat-button
            aria-label="Add Field" (click)="showAddReviewSetDialog()">
            <div class="fal fa-plus" style="font-size: 18px; margin-right: 10px; margin-top: 7px;"></div>
            <span>Add Review Set</span>
          </button>
        </div>
      </mat-toolbar>
      <mat-card appearance="outlined" class="card-under-toolbar" style="display: flex;">
        <mat-card-content style="flex: auto; display: flex; flex-direction: column; gap: 10px;">
          <div style="overflow: auto; height: 100%;">
            <table mat-table *ngIf="dataSource$ | async as dataSource" [dataSource]="dataSource" matSort matSortActive="name"
              matSortDirection="asc"
              class="table-width" style="width: 100%">
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
                <td mat-cell *matCellDef="let item" style="padding-right: 26px;">

                  <div
                    *inRole="[roles.DocReviewFeatureSet,roles.EditFeatureSet,roles.AccountFeatureSet, roles.Administrator]">
                    <div *ngIf="!item.isActive && item.status === 'reviewing'" style="display: flex;"
                      class="row-content">
                      <div *ngIf="item.remainingDocuments > 0"
                        style="display: flex; gap: 10px; white-space: nowrap; cursor: pointer;"
                        id="start-review-{{item.id}}" matTooltip="Check out a document and begin reviewing."
                        (click)="next(item)">
                        <div class="fal fa-play" style="font-size: 18px;"></div>
                        <div style="font-size: 16px">Start</div>
                      </div>
                      <div *ngIf="item.status === 'reviewing' && item.remainingDocuments < 1">
                        <div style="display: flex; gap: 10px; white-space: nowrap; cursor: pointer;"
                          id="start-review-{{item.id}}" matTooltip="Review is complete." (click)="next(item)">
                          <div class="fal fa-check" style="font-size: 18px;"></div>
                          <div style="font-size: 16px">Review Complete!</div>
                        </div>
                      </div>
                      <div *ngIf="item.status === 'post-review'"
                        style="display: flex; gap: 10px; white-space: nowrap; cursor: pointer;"
                        id="start-review-{{item.id}}" matTooltip="Review is complete." (click)="next(item)">
                        <div class="fal fa-check" style="font-size: 18px;"></div>
                        <div style="font-size: 16px">Review Complete!</div>
                      </div>
                    </div>
                    <div *ngIf="item.isActive" style="display: flex; gap: 20px;">
                      <div style="display: flex; gap: 10px; cursor: pointer;" id="continue-review-{{item.id}}"
                        matTooltip="Return back to reviewing documents." (click)="next(item)">
                        <div class="fal fa-play" style="font-size: 18px;"></div>
                        <div style="font-size: 16px">Continue</div>
                      </div>
                      <div style="display: flex; gap: 10px; cursor: pointer;" id="exit-review-{{item.id}}"
                        matTooltip="Release any checked out documents and exit review mode." (click)="exit(item)">
                        <div class="fal fa-stop" style="font-size: 18px;"></div>
                        <div style="font-size: 16px">Stop</div>
                      </div>
                    </div>
                    <div *ngIf="item.status === 'post-review'" style="display: flex;" class="row-content">
                      <div style="display: flex; gap: 10px; white-space: nowrap; cursor: pointer;"
                        id="start-review-{{item.id}}" matTooltip="Review is complete." (click)="next(item)">
                        <div class="fal fa-check" style="font-size: 18px;"></div>
                        <div style="font-size: 16px">Review Complete</div>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef matTooltip="Name" style="width: 500px" mat-sort-header="name">Name
                </th>
                <td mat-cell *matCellDef="let item" [routerLink]="['/', 'review', 'browse']"
                  [queryParams]="{ ReviewSetId: item.id }"
                  [ngClass]="{'disable-events': item.isReviewSetWorkflowActive}">
                  <div [matTooltip]="item.name"
                    style="min-height: 63px; display: flex; flex-direction: column; justify-content: center; width: 350px; padding-right: 20px; cursor: pointer;">
                    <div style="font-weight: 400; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{item.name}}</div>
                    <div *ngIf="item.lockedDocument"
                      style="margin-top: 3px; color: gray; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                      {{item.lockedDocument}}</div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="manage-actions">
                <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
                <td mat-cell *matCellDef="let item">
                  <div style="display: flex; gap: 20px; justify-content: end; white-space: nowrap" [ngClass]="{'disable-events': item.isReviewSetWorkflowActive}">
                    <div *ngIf="item.status === 'pre-review'" style="display: flex; gap: 10px; cursor: pointer;"
                      id="split-review-{{item.id}}" (click)="showSplitReviewSetDialog(item)"
                      matTooltip="Split Review Set"
                      [ngClass]="{'disable-events': item.totalDocuments <= 1}">
                      <div class="fas fa-file-dashed-line" style="font-size: 18px;"
                        [ngClass]="{'disabled-icon': (item.isReviewSetWorkflowActive || item.totalDocuments <= 1)}"></div>
                      <div style="font-size: 16px"></div>
                    </div>
                    <div style="display: flex; gap: 10px; cursor: pointer;" id="edit-review-{{item.id}}"
                      matTooltip="Edit Review Set" (click)="showEditReviewSetDialog(item)">
                      <div class="fas fa-edit" style="font-size: 18px;"
                        [ngClass]="{'disabled-icon': item.isReviewSetWorkflowActive}"></div>
                      <div style="font-size: 16px"></div>
                    </div>
                    <div *ngIf="item.status === 'pre-review'" style="display: flex; gap: 10px; cursor: pointer;"
                      id="start-review-{{item.id}}" matTooltip="Begin Review" (click)="startReviewSet(item)">
                      <div class="fal fa-circle-play" style="font-size: 18px;"
                        [ngClass]="{'disabled-icon': item.isReviewSetWorkflowActive}"></div>
                      <div style="font-size: 16px"></div>
                    </div>
                    <div *ngIf="item.status === 'reviewing'" style="display: flex; gap: 10px; cursor: pointer;"
                      matTooltip="Complete Review" id="complete-review-{{item.id}}" (click)="stopReviewSet(item)">
                      <div class="fas fa-circle-stop" style="font-size: 18px;"
                        [ngClass]="{'disabled-icon': item.isReviewSetWorkflowActive}"></div>
                      <div style="font-size: 16px"></div>
                    </div>
                    <div style="display: flex; gap: 10px; cursor: pointer;" id="delete-review-{{item.id}}"
                      matTooltip="Delete Review Set" (click)="delete(item)">
                      <div class="fas fa-trash" style="font-size: 18px;"
                        [ngClass]="{'disabled-icon': item.isReviewSetWorkflowActive}"></div>
                      <div style="font-size: 16px"></div>
                    </div>
                  </div>

                </td>
              </ng-container>
              <ng-container matColumnDef="reviewOrder">
                <th mat-header-cell *matHeaderCellDef matTooltip="In Review" style="width: 250px;"
                  mat-sort-header="reviewOrder">Review Order</th>
                <td mat-cell *matCellDef="let element">{{element.reviewOrder === 'master-date' ? "Master Date" : "Source File Path"}}</td>
              </ng-container>
              <ng-container matColumnDef="documentsInReview">
                <th mat-header-cell *matHeaderCellDef matTooltip="In Review" style="width: 250px;"
                  mat-sort-header="documentsInReview">In Review</th>
                <td mat-cell *matCellDef="let element">{{element.documentsInReview }}</td>
              </ng-container>
              <ng-container matColumnDef="remainingDocuments">
                <th mat-header-cell *matHeaderCellDef matTooltip="Remaining Documents" style="width: 250px;"
                  mat-sort-header="remainingDocuments">Remaining
                  Documents
                </th>
                <td mat-cell *matCellDef="let element">{{element.remainingDocuments }}</td>
              </ng-container>
              <ng-container matColumnDef="reviewedDocuments">
                <th mat-header-cell *matHeaderCellDef matTooltip="Reviewed Documents" style="width: 250px; "
                  mat-sort-header="reviewedDocuments">Reviewed
                  Documents
                </th>
                <td mat-cell *matCellDef="let element">{{element.reviewedDocuments }}</td>
              </ng-container>
              <ng-container matColumnDef="totalDocuments">
                <th mat-header-cell *matHeaderCellDef matTooltip="Total Documents" style="width: 250px;"
                  mat-sort-header="totalDocuments">Total
                  Documents
                </th>
                <td mat-cell *matCellDef="let element">{{element.totalDocuments }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
              <tr mat-row *matRowDef="let row; columns:columnsToDisplay"
                [ngClass]="{'disabled-row': row.isReviewSetWorkflowActive, }"
                [matTooltip]="row.toolTipMessage"
                [matTooltipDisabled]="!row.isReviewSetWorkflowActive"></tr>
            </table>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>